<div class="nav-bar">
  <header id="main-header" class="page-header headroom common-bottom-border">
    <div class="inner layout">
      <div class="site-logo-double inline-flex-display">
        <img src="assets/img/logo trm1 (1).svg" alt="Maryland State Retirement and Pension System"
          class="logo-img-style">
        <div class="block-display">
          <div> Employer </div>
          <div> Portal <span class="text-red" *ngIf="currentStage === '5'">(Sandbox)</span></div>
        </div>
      </div>
      <div class="site-navigation" *ngIf="showNavigation">
        <nav class="primary-navigation" id="navigation" role="navigation">
          <div id="block-nice_menus-3" class="main-navigation dd block block-nice_menus">
            <div class="block-inner">
              <div class="block-content content">
                <ul class="nice-menu nice-menu-down" id="nice-menu-3">
                  <!-- Nav Link -->
                  <li class="show depth-1 menuparent" *ngFor="let parent of links; let first = first;"
                    [ngClass]="first ? 'first' : ''">
                    <a (click)="parentRouterLink(parent, false)" class="menu-link depth-1"
                      [ngClass]="unreadMsgCount > 0 && parent === 'Home' ? 'add-margin-right' : ''">
                      <span class="menu-title" [ngClass]="setActiveClass(parent)">{{parent}}</span>
                      <span class="drop-icon" *ngIf="displayIcon(parent)"></span>
                    </a>
                    <div *ngIf="unreadMsgCount > 0 && parent === 'Home'" class="msg-cnt-container">
                      <span class="d-icon k-icon k-i-notification bell"></span>
                      <div class="notification">
                        <span class="notif-num" [ngClass]="setPaddingClass()">
                          <app-message-count [msgCount]="unreadMsgCount"></app-message-count>
                        </span>
                      </div>
                    </div>
                    <!-- DropDown Link -->
                    <ul class="show depth-2 not-last" *ngIf="displayIcon(parent)">
                      <li *ngFor="let child of getChildLinks(parent, false)">
                        <a class="menu-link depth-2" (click)="getRouterLink(parent,child)"
                          [ngClass]="setChildActiveClass(parent,child, false)">
                          <span class="menu-title contact-info">
                            {{child === 'Manage Users' && readConfigService.getDarkFeatureFlag(readConfigService.getIsEPOneReleaseDF())  ? readConfigService.getContactUserTitle() : child}}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="show depth-1 menuparent">
                    <a (click)="parentRouterLink('Account', false)" class="menu-link depth-1 last">
                      <span class="menu-title" [ngClass]="setActiveClass('Account')">Account</span>
                      <span class="drop-icon"></span>
                    </a>
                    <ul class="show depth-2 last">
                      <li *ngIf="multiOrg">
                        <a class="menu-link depth-2" (click)="selectOrg()">
                          Select Organization</a>
                      </li>
                      <li *ngIf="showAccountTab">
                        <a class="menu-link depth-2" [routerLink]="['account/contact-information']"
                          [ngClass]="setChildActiveClass('Account', 'Contact Information', false)">
                          Profile
                        </a>
                      </li>
                      <li>
                        <a class="menu-link depth-2" (click)="logout()">
                          Logout
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="site-toolbar" role="presentation" *ngIf="showNavigation">
        <button class="hamburger-icon" (click)="showMobileMenu()" role="button" type="button">
          <span class="hamburger">
            <span class="patty top" [ngClass]="setClass()"></span>
            <span class="patty middle" [ngClass]="setClass()"></span>
            <span class="patty bottom" [ngClass]="setClass()"></span>
          </span>
        </button>
      </div>
    </div>
  </header>
  <!-- Start mobile dehaze -->
  <div class="mobile-menu-panel" *ngIf="isMobileMenu && showNavigation">
    <div class="mobile-nav-layout">
      <div class="mobile-nav-inner">
        <kendo-panelbar [animate]="true" id="mobile-panel">
          <kendo-panelbar-item *ngFor="let parent of links" class="items" [title]="''"
            (click)="parentRouterLink(parent, true)">
            <ng-template kendoPanelBarItemTitle>
              <span class="item-heading" [ngClass]="setActiveClass(parent)">{{parent}}</span>
              <div *ngIf="unreadMsgCount > 0 && parent === 'Home'">
                <span class="m-icon k-icon k-i-notification bell"></span>
                <div class="m-notification">
                  <span class="notif-num" [ngClass]="setPaddingClass()">
                    <app-message-count [msgCount]="unreadMsgCount"></app-message-count>
                  </span>
                </div>
              </div>
            </ng-template>
            <ng-template kendoPanelBarContent *ngIf="displayIcon(parent)">
              <ul class="inner-menu-mobile">
                <li *ngFor="let child of getChildLinks(parent, true)" class="inner-menu-links"
                  (click)="getRouterLink(parent,child)">
                  <a class="menu-link depth-2"
                    [ngClass]="setChildActiveClass(parent,child,true)">{{child === 'Manage Users' && readConfigService.getDarkFeatureFlag(readConfigService.getIsEPOneReleaseDF())  ? readConfigService.getContactUserTitle() : child}}</a>
                </li>
              </ul>
            </ng-template>
          </kendo-panelbar-item>
          <kendo-panelbar-item class="items" [title]="''" [ngClass]="setActiveClass('Account')">
            <ng-template kendoPanelBarItemTitle>
              <span class="item-heading">Account</span>
            </ng-template>
            <ng-template kendoPanelBarContent>
              <ul class="inner-menu-mobile">
                <li class="inner-menu-links" *ngIf="multiOrg" (click)="selectOrg()">
                  <a class="menu-link depth-2">
                    Select Organization</a>
                </li>
                <li class="inner-menu-links" *ngIf="showAccountTab" [routerLink]="['account/contact-information']"
                  (click)="showMobileMenu()">
                  <a class="menu-link depth-2" [ngClass]="setChildActiveClass('Account','Contact Information', true)">
                    Profile
                  </a>
                </li>
                <li class="inner-menu-links" (click)="logout()">
                  <a class="menu-link depth-2">
                    Logout
                  </a>
                </li>
              </ul>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
        <div class="white-space">
        </div>
      </div>
    </div>
  </div>
  <!-- End mobile  -->
</div>
<div *ngIf="multiOrg">
  <div [style.visibility]="isRefreshed || hideOrgPopup ? 'hidden': 'visible'">
    <app-org-select [manual]="manual" (closeOrgDialog)="close()" (orgValue)="orgValue($event)">
    </app-org-select>
  </div>
</div>
<!-- Outage Notification  -->
<div id="outage-notif-div" *ngIf="showNotification" class="shared-notification" (click)="closeOutage()">
  <app-notification [divId]="'outage-notif-div'" [notifBody]="omessageBody"></app-notification>
</div>
